(function () {
  'use strict';

  angular.module('sempraWebapp').service('localeFilters', localeFiltersService);

  /** @ngInject */
  function localeFiltersService ($locale, currencyFilter, dateFilter, numberFilter) {

    this.defaultDateFormat = $locale.DATETIME_FORMATS.shortDate;

    this.currency = function (amount, currencySymbol, fractionSize) {
      return currencyFilter(amount, currencySymbol, fractionSize);
    };

    this.date = function (date, format, timezone) {
      if (!format) {
        format = $locale.DATETIME_FORMATS.shortDate;
      }
      return dateFilter(date, format, timezone);
    };

    this.monthYear = function (date) {
      return this.date(date, 'MMMM yyyy');
    };

    this.hourly = function (date) {
      return this.date(date, 'dd/MM/yy HH:mm');
    };

    this.daily = function (date) {
      return this.date(date, 'dd/MM/yy');
    };

    this.monthly = function (date) {
      return this.date(date, 'MM/yy');
    };

    this.yearly = function (date) {
      return this.date(date, 'yyyy');
    };

    this.number = function (number, fractionSize) {
      return numberFilter(number, fractionSize);
    };

    this.checkIfNumber = function (number) {
      if (Number.isInteger(number)) {
        return number
      }
    };

    this.getMonthLocale = function (monthIndex, long) {
      if (!long) {
        return $locale.DATETIME_FORMATS.SHORTMONTH[monthIndex];
      } else {
        return $locale.DATETIME_FORMATS.MONTH[monthIndex];
      }
    };

    this.getDayLocale = function (dayIndex, long) {
      if (!long) {
        return $locale.DATETIME_FORMATS.SHORTDAY[dayIndex];
      } else {
        return $locale.DATETIME_FORMATS.DAY[dayIndex];
      }
    }

  }
})();
